export default __webpack_public_path__ + "static/media/account_circle.7b46b69e.svg";